import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAuth } from "./axiosInstance";

export const fetchUserActivityUpdate = createAsyncThunk(
    'userActivityUpdate/fetchUserActivityUpdate',
    async ({ uid, subject, lesson_id, status }) => {      
        try {
          const response = await axiosAuth.post('https://ninjacurate.learntube.ai/update_user_activity', { uid: uid, subject: subject, lesson_id: lesson_id, status: status });
          return response.data;
        } catch (err) {
          console.log(err);
        }
  }
);

const updateUserActivitySlice = createSlice({
    name: 'updateUserActivity',
    initialState: {},
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchUserActivityUpdate.fulfilled, (state, action) => {
            return action.payload;
        });
    },
});

export default updateUserActivitySlice.reducer;